export const base64toFile = (base64String, filename) => {
  const base64Array = base64String.split(',');
  const mime = base64Array[0].match(/:(.*?);/)[1];
  const bstr = atob(base64Array[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {type: mime})
};

export function image64toCanvasRef (ref, image, crop, file) {
  return new Promise((resolve) => {
    const canvas = ref;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.ceil(crop.width * scaleX);
    canvas.height = Math.ceil(crop.height * scaleY);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    resolve(canvas.toDataURL(file.type))
  });
}
